import React, { useState, useEffect, useRef } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Clear from "@material-ui/icons/Clear";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MsgDataService from "../../services/MsgService";
import Loader from "react-loader-spinner";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
// New UI icon assets
import galleryIcon from "../../assets/images/CouselorMessages/SingleChat/gallary.png";
import attachmentIcon from "../../assets/images/CouselorMessages/SingleChat/attachment.png";
import smileIcon from "../../assets/images/CouselorMessages/SingleChat/simile.png";
import checkmarkIcon from "../../assets/images/CouselorMessages/SingleChat/Checkmark.png";
import checkmarkselected from "../../assets/images/CouselorMessages/SingleChat/Checkmark Selected.png";
import sendIcon from "../../assets/images/CouselorMessages/SingleChat/send.png";
import closeIcon from "../../assets/images/CouselorMessages/SingleChat/close.png";
import "./NewMessageModal.css";

const ModalExample = ({
  open,
  closeHandler,
  buttonLabel,
  isStudentOrCounselor,
  getMsgData,
  NameOrGroupName,
  setNameOrGroupName,
  setMsg,
  msg,
  selectedGroupMessageStudent,
  setShowErrorAlert,
  setShowSuccessAlert,
  setShowNotificationAlert,
  setOpen,
  setSelectedGroupMessageStudent,
  numberOfStudents,
  // page,
}) => {
  const ref = useRef();
  const inputRef = useRef();
  const timeout = useRef();
  const location = useLocation();
  const [page, setPage] = useState(1); // retained if pagination needed later
  const [cannedMsgData, setCannedMsgData] = useState("");
  const [openAccordion, setOpenAccordion] = useState(false);
  const [student, setStudent] = useState([]);
  const [showStudentContainer, setShowStudentContainer] = useState(false);
  const [loadingNameForStudent, setLoadingNameForStudent] = useState(false);
  const [messageId, setMessageId] = useState();
  const [selected, setSelected] = useState(false);
  const [selectedfile, setSelectedFile] = useState();
  const [fileDatafromApi, setFileDataFromApi] = useState();
  const userData = useSelector((state) => state.UserReducer.userObj);

  const messageInputHandler = (e) => setMsg(e.target.value);
  const handleFileChange = async () => setSelectedFile(ref.current.files[0]);

  // Fetch students for autocomplete
  const getStudentData = (value) => {
    if (typeof NameOrGroupName === "string") {
      MsgDataService.getList(isStudentOrCounselor, value)
        .then((data) => {
          setLoadingNameForStudent(false);
          setStudent(data.data.objects);
        })
        .catch(() => setLoadingNameForStudent(false));
    }
  };

  const handleNameOrGroupChange = () => {
    clearTimeout(timeout.current);
    if (!NameOrGroupName) {
      setShowStudentContainer(false);
      setStudent([]);
    }
    setLoadingNameForStudent(true);
  // Clear previous selection id when user types again
  setMessageId(undefined);
    setNameOrGroupName(inputRef.current.value);
    timeout.current = setTimeout(() => {
      getStudentData(inputRef.current.value);
    }, 800);
    setShowStudentContainer(true);
  };

  // Clear group selection when user starts typing
  const clearGroupSelection = () => {
    if (Array.isArray(NameOrGroupName) || NameOrGroupName === 'selected All') {
      setNameOrGroupName('');
      setMessageId(undefined);
    }
  };

  useEffect(() => {
    if (!msg) setSelected(false);
  }, [msg, NameOrGroupName]);

  const submitAttachment = () => {
    if (selectedfile) {
      MsgDataService.attachment(selectedfile)
        .then((data) => {
          setFileDataFromApi(data.data);
          ref.current.value = "";
        })
        .catch(() => {});
    }
  };
  useEffect(submitAttachment, [selectedfile]);

  const getCannedMsgData = () => {
    MsgDataService.getCannedMsgPage('recruiter', userData?.college, page)
      .then(data => setCannedMsgData(data.data?.result))
      .catch(() => {});
  };
  useEffect(getCannedMsgData, []);

  const accordionHandler = () => setOpenAccordion(!openAccordion);
  const selectTemplate = (item) => { setOpenAccordion(false); setMsg(item); };
  const selectStudent = (value) => { setNameOrGroupName(value); setMessageId(value?.id); setShowStudentContainer(false); };
  const sendCopyToParents = () => setSelected(!selected);

  // Prefill from route state and handle selected students from QueryResult
  useEffect(() => {
    // console.log("Location state in NewMessageModal:", location?.state);
    // console.log("selectedGroupMessageStudent:", selectedGroupMessageStudent);
    
    if (location?.state) {
      // Handle single student/counselor contact
      if (location.state.name && location.state.id) {
        setNameOrGroupName(location.state.name);
        setMessageId(location.state.id);
      }
      // Handle group message from QueryResult - array of students
      else if (Array.isArray(location.state) && location.state.length > 0) {
        setNameOrGroupName(location.state);
        // console.log("Set NameOrGroupName to array:", location.state);
      }
      // Handle "selected All" scenario
      else if (location.state === 'selected All') {
        setNameOrGroupName('selected All');
        // console.log("Set NameOrGroupName to 'selected All'");
      }
    }
    
    // Handle selectedGroupMessageStudent prop for group messaging
    if (selectedGroupMessageStudent) {
      if (Array.isArray(selectedGroupMessageStudent) && selectedGroupMessageStudent.length > 0) {
        setNameOrGroupName(selectedGroupMessageStudent);
        // console.log("Set NameOrGroupName from prop array:", selectedGroupMessageStudent);
      } else if (selectedGroupMessageStudent === 'selected All') {
        setNameOrGroupName('selected All');
        // console.log("Set NameOrGroupName from prop to 'selected All'");
      }
    }
  }, [location, selectedGroupMessageStudent]);

  const deleteAttachment = () => {
    if (!fileDatafromApi) return;
    let body = { message_file: fileDatafromApi?.Status?.image_name };
    MsgDataService.deleteattachment(body).finally(() => setFileDataFromApi());
  };

  const sendMessage = (e) => {
    if (msg === "" || msg === "undefined") { e.preventDefault(); return; }
    let selectedStudent = [];
    if (Array.isArray(NameOrGroupName)) {
      NameOrGroupName.forEach(item => {
        // Get student ID from either 'id', '16', or fallback
        const studentId = item.id || item["16"];
        if (studentId) {
          selectedStudent.push(studentId);
        }
      });
    }
    const inCounselorContext = (location?.pathname || '').startsWith('/counselor') || (location?.pathname || '').startsWith('/super_admin');
    let obj = {
      message_body: typeof msg === "object" ? msg.messages.en.body : msg,
      dst_id: Array.isArray(NameOrGroupName) ? selectedStudent : [messageId],
      event_type:
        isStudentOrCounselor === "counselors" ? "recruiter_counselor" :
        isStudentOrCounselor === "students" ? (inCounselorContext ? "counselor_student" : "recruiter_student") :
        isStudentOrCounselor === "international-students" ? "international_student" : null
    };
    if (fileDatafromApi) obj.attachment_url = fileDatafromApi?.Status?.image_name;
    if (selected) obj.parent_ack = selected;
    setShowNotificationAlert(true);
    setNameOrGroupName(); setMsg(); setSelected(false); setSelectedGroupMessageStudent([]); setOpen(false);
    MsgDataService.sendMessage(obj)
      .then((data) => { data?.data?.error ? setShowErrorAlert(true) : setShowSuccessAlert(true); getMsgData(); })
      .catch(() => setShowErrorAlert(true))
      .finally(() => { setShowNotificationAlert(false); setFileDataFromApi(); });
  };

  const sendMessageWhenAllSelected = (e) => {
    if (msg === "" || msg === "undefined") { e.preventDefault(); return; }
    let query = JSON.parse(localStorage.getItem("query"));
    const inCounselorContext = (location?.pathname || '').startsWith('/counselor') || (location?.pathname || '').startsWith('/super_admin');
    let obj = {
      message_body: typeof msg === "object" ? msg.messages.en.body : msg,
      is_all: true,
      query: [query],
      event_type:
        isStudentOrCounselor === "counselors" ? "recruiter_counselor" :
        isStudentOrCounselor === "students" ? (inCounselorContext ? "counselor_student" : "recruiter_student") :
        isStudentOrCounselor === "international-students" ? "international_student" : null
    };
    if (isStudentOrCounselor === "international-students") obj.is_international = true;
    if (selected) obj.parent_ack = selected;
    if (fileDatafromApi) obj.attachment_url = fileDatafromApi?.Status?.image_name;
    setShowNotificationAlert(true);
    setNameOrGroupName(); setMsg(); setSelected(false); setSelectedGroupMessageStudent([]); setOpen(false);
    MsgDataService.query_result_message(obj)
      .then(() => { getMsgData(); setShowSuccessAlert(true); })
      .catch(() => setShowErrorAlert(true))
      .finally(() => { setShowNotificationAlert(false); setFileDataFromApi(); });
  };

  const onModalClose = () => { setNameOrGroupName(); setStudent([]); setLoadingNameForStudent(false); setShowStudentContainer(false); closeHandler(); };

  // UI RENDER
  return (
    <div>
  <Modal isOpen={open} toggle={onModalClose} centered size="xl" modalClassName="newMessageModalDialog">
        <ModalHeader style={{ borderBottom: 'none', padding: '16px 24px 4px', position: 'relative' }}>
          <h5 style={{ margin: 0, fontWeight: 600, fontSize: 20 }}>New Message</h5>
          <img 
            src={closeIcon} 
            alt="close" 
            onClick={onModalClose} 
            className="modal-close-icon"
            style={{ width: 30, height: 30, cursor: 'pointer', position: 'absolute', right: 16, top: 12 }} 
          />
        </ModalHeader>
        <ModalBody style={{ padding: '8px 24px 24px' }}>
          {/* Recipient selector */}
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#09425A', marginBottom: 6, display: 'block' }}>Recipient</label>
            <div style={{ position: 'relative' }}>
              {/* Show selected students from QueryResult */}
              {Array.isArray(NameOrGroupName) && NameOrGroupName.length > 0 ? (
                <div style={{
                  width: '100%',
                  background: '#F8F9FA',
                  border: '2px solid #75BF43',
                  borderRadius: 14,
                  padding: '12px 16px',
                  fontSize: 15,
                  minHeight: 48,
                  maxHeight: 200,
                  overflowY: 'auto'
                }}>
                  {NameOrGroupName.length === 1 ? (
                    <div style={{ color: '#09425A', fontWeight: 500 }}>
                      {`${NameOrGroupName[0]["1"] || 'Unknown'} ${NameOrGroupName[0]["2"] || 'Student'}`}
                    </div>
                  ) : (
                    <div style={{ color: '#09425A', fontWeight: 500 }}>
                      {`${NameOrGroupName.length} students selected`}
                      <div style={{ fontSize: 13, marginTop: 4, color: '#666', maxHeight: 120, overflowY: 'auto' }}>
                        {NameOrGroupName.map((student, idx) => (
                          <div key={idx} style={{ marginBottom: 2 }}>
                            • {`${student["1"] || 'Unknown'} ${student["2"] || 'Student'}`}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ) : NameOrGroupName === 'selected All' ? (
                <div style={{
                  width: '100%',
                  background: '#F8F9FA',
                  border: '2px solid #75BF43',
                  borderRadius: 14,
                  padding: '12px 16px',
                  fontSize: 15,
                  color: '#09425A',
                  fontWeight: 500
                }}>
                  {`All students selected (${numberOfStudents || 'All'} students)`}
                </div>
              ) : (
                <input
                  ref={inputRef}
                  value={typeof NameOrGroupName === 'object' && NameOrGroupName?.name
                      ? NameOrGroupName.name
                      : (NameOrGroupName || '')}
                  placeholder={`Search ${isStudentOrCounselor?.replace(/-/g, ' ')}`}
                  onChange={handleNameOrGroupChange}
                  onFocus={clearGroupSelection}
                  style={{
                    width: '100%',
                    background: '#FFFFFF',
                    border: '2px solid #75BF43',
                    borderRadius: 14,
                    padding: '12px 16px',
                    fontSize: 15,
                    outline: 'none'
                  }}
                />
              )}
              {loadingNameForStudent && (
                <div style={{ position: 'absolute', top: 10, right: 14 }}>
                  <Loader type="ThreeDots" color="#1395F2" height={30} width={30} />
                </div>
              )}
              {showStudentContainer && student?.length > 0 && !Array.isArray(NameOrGroupName) && NameOrGroupName !== 'selected All' && (
                <div style={{ position: 'absolute', top: 54, left: 0, right: 0, background: '#fff', border: '1px solid #D0E4F1', borderRadius: 12, maxHeight: 220, overflowY: 'auto', zIndex: 10 }}>
                  {student.map((itm) => (
                    <div
                      key={itm.id}
                      onClick={() => selectStudent(itm)}
                      style={{ padding: '10px 14px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', fontSize: 14 }}
                    >
                      <span>{itm.name}</span>
                      <span style={{ opacity: .6 }}>{itm.grad_year}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Scheduled message templates (match Counselor style) */}
          <div style={{ marginBottom: 16 }}>
            <div
              role="button"
              tabIndex={0}
              onClick={accordionHandler}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && accordionHandler()}
              style={{
                width: '100%',
                background: '#FFFFFF',
                border: '2px solid #75BF43',
                borderRadius: 22,
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                // fontWeight: 600,
                // color: '#09425A',
                cursor: 'pointer'
              }}
            >
              <span>Choose a Scheduled Message Template</span>
              <span style={{ transform: openAccordion ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform .2s ease' }}>
                <KeyboardArrowDownIcon style={{ color: '#09425A' }} />
              </span>
            </div>
            {openAccordion && (
              <div style={{
                background: '#FFFFFF',
                border: '1px solid #D0E4F1',
                borderRadius: 14,
                maxHeight: 260,
                overflowY: 'auto',
                marginTop: 8,
                padding: 8
              }}>
                {Array.isArray(cannedMsgData) && cannedMsgData.length > 0 ? (
                  cannedMsgData.map((item, idx) => (
                    <div
                      key={idx}
                      onClick={() => selectTemplate(item)}
                      style={{
                        border: '1px solid #E7F2FA',
                        borderRadius: 12,
                        padding: '10px 12px',
                        margin: '8px 6px',
                        cursor: 'pointer',
                        background: '#F9FCFF'
                      }}
                    >
                      <div style={{ fontWeight: 700, color: '#0F2434', marginBottom: 6 }}>
                        {item?.messages?.en?.subject || 'Untitled'}
                      </div>
                      <div style={{ color: '#406079', fontSize: 14, whiteSpace: 'pre-wrap' }}>
                        {item?.messages?.en?.body}
                      </div>
                    </div>
                  ))
                ) : (
                  <div style={{ padding: 12, color: '#406079' }}>No templates available.</div>
                )}
              </div>
            )}
          </div>

          {/* Message composer */}
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#09425A', marginBottom: 6, display: 'block' }}>Message</label>
              <textarea
                rows={5}
                placeholder="Type your message..."
                value={typeof msg === 'object' ? msg.messages.en.body : (msg || '')}
                onChange={messageInputHandler}
                style={{
                  width: '100%',
                  background: '#FFFFFF',
                  border: '2px solid #75BF43',
                  borderRadius: 22,
                  padding: '14px 16px',
                  fontSize: 15,
                  outline: 'none',
                  resize: 'vertical',
                  minHeight: 120
                }}
              />
            </div>

          {/* Action bar */}
          <div style={{ padding: '12px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', columnGap: 24, flexWrap: 'nowrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', columnGap: 20, flexWrap: 'nowrap', flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0 }}>
                <div style={{ cursor: 'pointer', width: 46, height: 46, borderRadius: 12, background: '#E5F4E4', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={galleryIcon} alt="gallery" style={{ width: 28, height: 28 }} />
                </div>
                <div style={{ cursor: 'pointer', width: 46, height: 46, borderRadius: 12, background: '#E5F4E4', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <label htmlFor="fileUploaderRecruiterModal" style={{ cursor: 'pointer', margin: 0, display: 'flex' }}>
                    <img src={attachmentIcon} alt="attachment" style={{ width: 26, height: 26 }} />
                  </label>
                  <input id="fileUploaderRecruiterModal" type="file" ref={ref} onChange={handleFileChange} style={{ display: 'none' }} />
                </div>
                <div style={{ cursor: 'pointer', width: 46, height: 46, borderRadius: 12, background: '#E5F4E4', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={smileIcon} alt="emoji" style={{ width: 28, height: 28 }} />
                </div>
              </div>
              {(isStudentOrCounselor === 'students' || isStudentOrCounselor === 'international-students') && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginLeft: 12, whiteSpace: 'nowrap' }}>
                  <div
                    onClick={sendCopyToParents}
                    style={{ cursor: 'pointer', width: 54, height: 54, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all .25s ease' }}
                  >
                    <img src={selected ? checkmarkselected : checkmarkIcon} alt={selected ? 'checked' : 'unchecked'} style={{ width: 28, height: 28 }} />
                  </div>
                  <span
                    onClick={sendCopyToParents}
                    style={{ cursor: 'pointer', fontSize: 14, fontWeight: 500 }}
                  >
                    Send copy to parent
                  </span>
                </div>
              )}
              {fileDatafromApi && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <p style={{ color: '#008000', marginBottom: 0 }}>
                    {fileDatafromApi?.Status?.filename.slice(0, 15)}
                  </p>
                  <div onClick={deleteAttachment} style={{ cursor: 'pointer' }}>
                    <Clear className="cancelAttachment" />
                  </div>
                </div>
              )}
            </div>
            <button
              onClick={
                NameOrGroupName === 'selected All'
                  ? sendMessageWhenAllSelected
                  : sendMessage
              }
              className="sendmessage"
              style={{
                background: '#1395F2',
                border: '3px solid #FFFFFF',
                color: '#FFFFFF',
                padding: '14px 34px',
                borderRadius: 18,
                fontSize: 16,
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                boxShadow: '0 0 0 2px #1395F2',
                cursor: NameOrGroupName === 'selected All'
                  ? (!msg ? 'not-allowed' : 'pointer')
                  : (!msg || !(Array.isArray(NameOrGroupName) ? NameOrGroupName.length > 0 : messageId) ? 'not-allowed' : 'pointer'),
                opacity: NameOrGroupName === 'selected All'
                  ? (!msg ? .5 : 1)
                  : (!msg || !(Array.isArray(NameOrGroupName) ? NameOrGroupName.length > 0 : messageId) ? .5 : 1),
                transition: 'opacity .3s ease'
              }}
              disabled={NameOrGroupName === 'selected All' ? !msg : (!msg || !(Array.isArray(NameOrGroupName) ? NameOrGroupName.length > 0 : messageId))}
            >
              <img src={sendIcon} alt="send" style={{ width: 22, height: 22 }} />
              SEND
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ModalExample;